import { render, staticRenderFns } from "./SelfPublishingFlowMetadata.vue?vue&type=template&id=8b4c67a6&scoped=true&"
import script from "./SelfPublishingFlowMetadata.vue?vue&type=script&lang=js&"
export * from "./SelfPublishingFlowMetadata.vue?vue&type=script&lang=js&"
import style0 from "./SelfPublishingFlowMetadata.vue?vue&type=style&index=0&id=8b4c67a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4c67a6",
  null
  
)

export default component.exports